module.exports = __webpack_public_path__ + "img/arrow-en.9cbf9a85.svg";